import React, { useState, useEffect, forwardRef, useRef, Fragment } from "react";
import { Button } from '../../components/Wrappers'
import { TextField, InputAdornment,
         FormControl, InputLabel, Select, Input, Chip, MenuItem,
         NativeSelect} from "@material-ui/core";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';

// components
import SelectCustomer from '../../components/Customer/SelectCustomer';

// Icons
import {
    CalendarToday as CalendarTodayIcon,
    HomeWork as HomeWorkIcon
} from '@material-ui/icons'

import { useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";

import "./Refund.css";

registerLocale('en-NZ', enNZ);


const RefundSummary = forwardRef((props, ref) => {
    var classes = useStyles();
    var { regions } = useUserState();
    const fromRef = useRef(null);
    const toRef = useRef(null);
    const [selectedFrom, setSelectedFrom] = React.useState();
    const [selectedTo, setSelectedTo] = React.useState();
    const fromCalendarRef = useRef(null);
    const toCalendarRef = useRef(null);
    const [fromOpen, setFromOpen] = React.useState(false);
    const [toOpen, setToOpen] = React.useState(false);
    const [fromFocused, setFromFocused] = React.useState(false);
    const [toFocused, setToFocused] = React.useState(false);
    const [isTimeRangeInvalid, setIsTimeRangeInvalid] = React.useState(false);
    const [selectedType, setSelectedType] = useState('r');


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    useEffect(() => {
      if (fromCalendarRef !== undefined && fromCalendarRef !== null &&
        fromCalendarRef.current !== undefined && fromCalendarRef.current !== null) {
        fromCalendarRef.current.setOpen(fromFocused);
      }
    },[fromFocused]);

    useEffect(() => {
      if (toCalendarRef !== undefined && toCalendarRef !== null &&
        toCalendarRef.current !== undefined && toCalendarRef.current !== null) {
        toCalendarRef.current.setOpen(toFocused);
      }
    },[toFocused]);

    function getTwoWeekTimerange() {
        // Get today's date
        let today = new Date();

        // Calculate the start of the week (Monday) from two weeks ago
        let twoWeeksAgoMonday = new Date(today);
        twoWeeksAgoMonday.setDate(twoWeeksAgoMonday.getDate() - (today.getDay() + 6) % 7 - 14); // Subtract 14 days for two weeks ago
        twoWeeksAgoMonday.setHours(10, 30, 0, 0); // Set time to 10:30 am

        // Calculate the end of the week (Sunday) from last week
        let thisMonday = new Date(today);
        thisMonday.setDate(thisMonday.getDate() - today.getDay() + 1); // Subtract days until this Monday
        thisMonday.setHours(10, 30, 0, 0); // Set time to 10:30am of the day

        return {
            start: twoWeeksAgoMonday,
            end: thisMonday
        };
    }

    useEffect(() => {
      let timerange = getTwoWeekTimerange();
      setSelectedFrom(timerange.start);
      setSelectedTo(timerange.end);
    },[]);


    const onMouseDown = e => {
      e.stopPropagation();
    };

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeFrom(d) {
      setSelectedFrom(d);
    }

    function handleChangeTo(d) {
      setSelectedTo(d);
    }

    function onFocusFrom(event) {
      setFromFocused(true);
    }

    function onFocusTo(event) {
      setToFocused(true);
    }

    function blurFrom(event) {
      setFromFocused(false);
    }

    function blurTo(event) {
      setToFocused(false);
    }

    function handleSelectFrom(d) {
      setSelectedFrom(d);
    }

    function handleSelectTo(d) {
      setSelectedTo(d);
    }

    // triggered if use keyboard
    function handleFromKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setFromFocused(false);
      }
    }

    function handleToKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setToFocused(false);
      }
    }

    function handleSelectedType(e) {
        setSelectedType(e.target.value);
    }


    function generateRefundReport() {
      var from = selectedFrom;
      var to = selectedTo;

      if (from === undefined || from === null || to === undefined || to === null) {
          let timerange = getTwoWeekTimerange();
          from = timerange.start;
          to = timerange.end;
      }

      let [f_date, f_month, f_year] = from.toLocaleDateString('en-NZ').split("/");
      let f_hour = ('0' + from.getHours()).slice(-2);
      let f_minute = ('0' + from.getMinutes()).slice(-2);
      let f_time = `${f_hour}:${f_minute}`;
      let [t_date, t_month, t_year] = to.toLocaleDateString('en-NZ').split("/");
      let t_hour = ('0' + to.getHours()).slice(-2);
      let t_minute = ('0' + to.getMinutes()).slice(-2);
      let t_time = `${t_hour}:${t_minute}`;

      console.log(`${config.clientApi}/reports/refund/summary?&type=${selectedType}&start=${f_year}-${f_month}-${f_date}%20${encodeURIComponent(f_time)}&end=${t_year}-${t_month}-${t_date}%20${encodeURIComponent(t_time)}`);
      window.open(
          `${config.clientApi}/reports/refund/summary?&type=${selectedType}&start=${f_year}-${f_month}-${f_date}%20${encodeURIComponent(f_time)}&end=${t_year}-${t_month}-${t_date}%20${encodeURIComponent(t_time)}`,
          '_blank'
      );
    }




    return (
      <>

                <div className={classes.reportCalendars}>
                    <TextField
                      id="from"
                      ref={fromRef}
                      label="From"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: fromFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={fromCalendarRef}
                          className={classes.textField}
                          selected={selectedFrom}
                          onChange={handleChangeFrom}
                          onFocus={onFocusFrom}
                          onSelect={handleSelectFrom}
                          onClickOutside={blurFrom}
                          onKeyDown={handleFromKeyPress}
                          locale="en-NZ"
                          showTimeSelect
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy hh:mm aa"
                          />
                        }}
                    />
                    <TextField
                      id="to"
                      ref={toRef}
                      label="To"
                      className={classnames({
                      'textField': true,
                      'reportCalendarField': true,
                      [classes.calendarFocused]: toFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={toCalendarRef}
                          className={classes.textField}
                          selected={selectedTo}
                          onChange={handleChangeTo}
                          onFocus={onFocusTo}
                          onSelect={handleSelectTo}
                          onClickOutside={blurTo}
                          onKeyDown={handleToKeyPress}
                          locale="en-NZ"
                          showTimeSelect
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy hh:mm aa"
                          />
                        }}
                    />

                    <FormControl variant="outlined" style={{ marginBottom: 20 }}
                      className={classnames({
                          'select-control': true
                        })}>
                      <InputLabel>Type:</InputLabel>
                      <div className={classnames({
                                    'select-control-input': true,
                                    'overdue-select-control-input': true
                                  })}>
                        <NativeSelect
                          value={selectedType}
                          onChange={handleSelectedType}
                        >
                           <option value="ALL">ALL</option>
                           <option value="r">Refund</option>
                           <option value="e">Declaration of Expense</option>
                        </NativeSelect>
                      </div>
                    </FormControl>

                </div>


                <div className={classes.layoutButtonsRow}>
                    <Button onClick={generateRefundReport} >
                      <span>create</span>
                    </Button>
                </div>

      </>
    );
});

export default RefundSummary;
